import getBasePath from '@/common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'extensao');

const extensaoActions = {
  ...genericActions(basePath),
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}{&idsNiveisExtensao*}{&idsDependencias*}` },
  listarAtivosComListaCnpj: { method: 'GET', url: `${basePath}/selecao-grupo-fornecedor/?tamanhoPagina={tamanhoPagina}&idNivelExtensao={idNivelExtensao}&autocomplete={autocomplete}{&idsGruposFornecedor*}{&idsExtensao*}` },
  listarExtensoes: { method: 'GET', url: `${basePath}?nome={nome}&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}{&idsNiveisExtensao*}{&idsDependencias*}` },
  listarPorUsuario: { method: 'GET', url: `${basePath}?tamanhoPagina=10&numeroPagina=1&nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&usuarioLogado=true` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  atualizarAutoRelacionamento: { method: 'PUT', url: `${basePath}/auto-relacionamento` },
  gravarAutoRelacionamento: { method: 'POST', url: `${basePath}/auto-relacionamento` },
  listarNiveisExtensao: { method: 'GET', url: `${basePath}/nivel-extensao?{&idsNiveisExtensao*}` },
  listarDetalhado: { method: 'GET', url: `${basePath}/detalhado?tamanhoPagina={size}&numeroPagina={page}{&idsNiveisExtensao*}` },
  listarNiveisExtensaoEntidade: { method: 'GET', url: `${basePath}/nivel-extensao/{entidade}` },
  selecao: { method: 'GET', url: `${basePath}/selecao?{&idsDependencias*}` },
};

export default (resource) => resource(`${basePath}`, {}, extensaoActions);
